import React from 'react'

const NotFound = () => {
	return (
		<div style={{ margin: '20vh auto' }}>
			<h1>Page not found</h1>
		</div>
	)
}

export default NotFound